import React, { Component } from "react";
import {Link} from 'react-router-dom'

export default class Join extends Component {
  render() {
    return (
      <div className="pt-3">
        <div className="container d-flex justify-content-center align-items-center flex-column mt-5">
          <div class="lds-dual-ring">
            <div class="lds-dual-second"></div>
              <img
                class="image-cover loading"
                src="https://media.istockphoto.com/photos/happy-laughing-man-picture-id544358212?k=6&m=544358212&s=612x612&w=0&h=odURMNz2hty8LIfpVahaaUKpGU4vd-UlZx4jy-OAnJA="
                alt="Card image"
              />
            
          </div>
          <h3 className="text-primary text-center mt-2">
            Please wait...
            <br />
            Connecting your trainer
          </h3>
        </div>
        <div className="connecting-footer">
          <div className="text-center">
            <h4 className>Math</h4>
            <p className="blockquote-footer">By James stunner</p>
          </div>
        </div>
      </div>
    );
  }
}
